$(function(){
  $('.p-entry-faqItem').on('click',function(){
    if($(this).find('.p-entry-faqItem__question').hasClass('is-open')){
      $(this).find('.p-entry-faqItem__question').removeClass('is-open');
      $(this).find('.p-entry-faqItem__answer').removeClass('is-open');
    }else{
      $(this).find('.p-entry-faqItem__question').addClass('is-open');
      $(this).find('.p-entry-faqItem__answer').addClass('is-open');
    }
  });
});

$(function(){
  // showNewsInnerクラスのホバーイベント
  $('.showNewsInner').hover(
    function() { // マウスが要素に入ったとき
      $(this).css('background-color', '#311e1642');
      $(this).find('.newsLinkBox').css('background-color', 'unset');
      $(this).find('.newsLinkBox').find('p').css('color', '#311e16');
    },
    function() { // マウスが要素から出たとき
      $(this).css('background-color', '');
      $(this).find('.newsLinkBox').css('background-color', '#311e16');
      $(this).find('.newsLinkBox').find('p').css('color', '#ffffff');
    }
  );
});

document.addEventListener('DOMContentLoaded', () => {
  const fadeInElements = document.querySelectorAll('.c-service-about__title, .c-service-about__title-remarks, .c-service-about__desc-wrap .in-title, .c-service-about__desc-wrap p');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
      }
    });
  }, {
    threshold: 0.3,
  });

  fadeInElements.forEach(el => observer.observe(el));
});


$(function(){
  const $modal = $('.course-roadmap .cr-modal');
  const $img   = $modal.find('.cr-modal__img');
  const $close = $modal.find('[data-cr-close]');
  let $last = null;

  function openModal(src, alt){
    $last = $(document.activeElement);
    $img.attr({src: src, alt: alt || 'ロードマップ（拡大）'});
    $modal.addClass('is-open').attr('aria-hidden','false');
    $modal.find('.cr-modal__close').trigger('focus');
    $('html').css('overflow','hidden');
  }
  function closeModal(){
    $modal.removeClass('is-open').attr('aria-hidden','true');
    $img.attr({src:''});
    $('html').css('overflow','');
    if ($last && $last.length) $last.trigger('focus');
  }

  $('.course-roadmap .roadmap-thumb').on('click', function(){
    const src = $(this).data('full');
    const alt = $(this).find('img').attr('alt') || '';
    openModal(src, alt);
  });

  // 拡大を開いたまま別ページへ移っても、<html> に付けたスクロール止めを残さない
  document.addEventListener('turbolinks:before-render', function(){ $('html').css('overflow',''); }, { once: true });

  $close.on('click', closeModal);
  $modal.on('click', function(e){
    if ($(e.target).hasClass('cr-modal__backdrop')) closeModal();
  });
  $(document).on('keydown', function(e){
    if (e.key === 'Escape' && $modal.hasClass('is-open')) closeModal();
  });
});
// 文節で折り返す対象。newmembers.scss の auto-phrase と同じ範囲にそろえる
const PHRASE_TARGETS = [
  'p', 'li', 'h1', 'h2', 'h3', 'h4',
  '.p-entry-faqItem__question', '.p-entry-flowItem__ttl'
].map((s) => `.newmembermain ${s}`).join(',');

// ページ全体の演出。文言と画像には触らず、class を付け外しするだけ。
// 動きを減らす設定の人には、光の粒もスクロール演出も付けない。
document.addEventListener('DOMContentLoaded', () => {
  const page = document.querySelector('.newmembermain');
  if (!page) return;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // 0. 日本語の改行を文節で。閲覧の8〜9割はスマホで、狭い幅では「か？」「す。」だけの行や
  //    「コンテンツマネージ／ャー」のような語の途中の改行が目立つ。
  //    Chrome 系は CSS の word-break: auto-phrase（newmembers.scss）に任せ、
  //    それが効かない Safari（iPhone）だけ BudouX で文節の切れ目に <wbr> を入れる。文字は変えない。
  //    BudouX は別ファイルにして、必要なブラウザだけが読み込む。
  if (!(window.CSS && CSS.supports('word-break', 'auto-phrase'))) {
    // 日本語のモデルだけを読む（パッケージ入口から読むとタイ語・中国語のモデルも付いてくる）
    Promise.all([
      import(/* webpackChunkName: "budoux" */ 'budoux/module/html_processor.js'),
      import(/* webpackChunkName: "budoux" */ 'budoux/module/data/models/ja.js')
    ]).then(([{ HTMLProcessingParser }, { model }]) => {
      const parser = new HTMLProcessingParser(model);
      page.querySelectorAll(PHRASE_TARGETS).forEach((el) => {
        if (el.closest('.lineBlock')) return; // 線ではさんだ短い見出しは1行のまま（scss と同じ）
        if (/[\u3040-\u30ff\u4e00-\u9fff]/.test(el.textContent)) parser.applyToElement(el);
      });
    }).catch(() => {}); // 読めなくても、ふつうの改行のまま表示される
  }

  // 1. ファーストビューの光の粒
  const hero = page.querySelector('.secondlayer');
  if (hero && !reduceMotion) {
    const layer = document.createElement('div');
    layer.className = 'nmSparkles';
    layer.setAttribute('aria-hidden', 'true');
    const count = window.innerWidth < 840 ? 14 : 26;
    for (let i = 0; i < count; i++) {
      const s = document.createElement('span');
      s.style.left = `${Math.random() * 100}%`;
      s.style.top = `${Math.random() * 70}%`;
      s.style.setProperty('--s', `${2 + Math.random() * 4}px`);
      s.style.setProperty('--d', `${3 + Math.random() * 4}s`);
      s.style.setProperty('--w', `${Math.random() * 5}s`);
      layer.appendChild(s);
    }
    hero.prepend(layer);
  }

  // 2. スクロールで下からふわっと出す。同じ親の中では順番に少しずつ遅らせる
  if (!reduceMotion && 'IntersectionObserver' in window) {
    const groups = [
      '.aboutSection .eachBox > *', '.aboutSection .aboutLink',
      '.course-roadmap .section-title', '.course-roadmap .section-lead', '.course-roadmap .roadmap-card', '.course-roadmap .roadmap-note',
      '.circusServiceSection .titleBox', '.circusServiceSection .serviceImg', '.circusServiceSection .circusServictext',
      '.showNewsIndexforjoinus .topMessage', '.showNewsIndexforjoinus .showNewsOuter',
      '.ourValues .valueBox',
      '.fifthlayer .lineBlock', '.fifthlayer .applyterms',
      '.forthlayer .lineBlock', '.forthlayer .p-entry-flowItem',
      '.sixthlayer .lineBlock', '.sixthlayer .p-entry-faqItem',
      '.seventhlayer .lineBlock', '.seventhlayer .entryForm',
      '.p-footer-recruit__inner'
    ];
    const targets = [];
    groups.forEach((selector) => {
      page.querySelectorAll(selector).forEach((el) => {
        const siblings = Array.from(el.parentElement.children).filter((c) => c.matches(selector));
        const index = Math.min(siblings.indexOf(el), 5);
        el.style.setProperty('--nm-delay', `${index * 0.08}s`);
        el.classList.add('nm-reveal');
        targets.push(el);
      });
    });
    const revealer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          revealer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    targets.forEach((el) => revealer.observe(el));
  }
});
